import { gql } from 'urql'

/** Poll rápido (~30s): superficie + uptime. No carga Vultr/Atlas/colas. */
export const GET_PORTAL_HEALTH_SURFACE = gql`
  query PortalHealthSurface {
    portalHealthSurface {
      checkedAt
      overall
      portalUp
      summary
      indicators {
        id
        group
        label
        status
        summary
        detail
        checkedAt
      }
      uptime {
        windowHours
        uptimePct
        downtimeMinutes
        samples
        points {
          at
          label
          upPct
          samples
          downSamples
          status
          failures {
            id
            label
            status
            summary
          }
        }
        segments {
          at
          up
          overall
          summary
          failures {
            id
            label
            status
            summary
          }
        }
      }
    }
  }
`

export const GET_PORTAL_HEALTH = gql`
  query PortalHealth {
    portalHealth {
      checkedAt
      overall
      summary
      indicators {
        id
        group
        label
        status
        summary
        detail
        checkedAt
      }
      fleet {
        name
        namespace
        tier
        desired
        ready
        unavailable
        pending
        restarts
        cpuPct
        memPct
        status
        reason
        podReasons
        crashLoopCount
        imagePullCount
        oomCount
      }
      nodes {
        name
        ready
        status
        reason
        cpuPct
        memPct
        instanceType
        zone
        taints
        createdAt
        checkedAt
      }
      rabbitQueues {
        name
        vhost
        areas
        node
        state
        consumers
        ready
        unacked
        total
        publishRate
        deliverRate
        ackRate
        consumeMode
        status
        checkedAt
      }
      rabbitNodes {
        name
        running
        memAlarm
        diskAlarm
        memUsedBytes
        memLimitBytes
        memPct
        status
        reason
        checkedAt
      }
      vultrInstances {
        id
        label
        hostname
        region
        plan
        os
        mainIp
        instanceStatus
        instanceStatusHealth
        powerStatus
        powerStatusHealth
        serverStatus
        serverStatusHealth
        uso
        status
        summary
        checkedAt
      }
      mongoProcesses {
        id
        hostname
        typeName
        isPrimary
        userAlias
        replicaSetName
        clusterName
        memPct
        memUsedBytes
        memAvailBytes
        connections
        cpuNormPct
        status
        summary
        checkedAt
      }
      mcpChain {
        status
        summary
        checkedAt
        hops {
          id
          label
          status
          summary
          detail
        }
      }
      siiBacklog {
        status
        summary
        totalReady
        checkedAt
        queues {
          name
          ready
          unacked
          total
          consumeMode
          status
        }
      }
      heavyTraffic {
        checkedAt
        windowMinutes
        summary
        status
        users {
          userId
          email
          requests
          s5xx
          pods
          origens
        }
        byPod {
          podHostname
          requests
          s5xx
          topUserId
        }
        hotDeployments {
          deployment
          memPct
          cpuPct
          status
          expected
          note
        }
      }
      uptime {
        windowHours
        uptimePct
        downtimeMinutes
        samples
        points {
          at
          label
          upPct
          samples
          downSamples
          status
          failures {
            id
            label
            status
            summary
          }
        }
        segments {
          at
          up
          overall
          summary
          failures {
            id
            label
            status
            summary
          }
        }
      }
    }
  }
`

export const GET_DEPLOYMENT_DETAIL = gql`
  query PortalHealthDeploymentDetail($name: String!, $namespace: String!) {
    portalHealthDeploymentDetail(name: $name, namespace: $namespace) {
      name
      namespace
      image
      desired
      ready
      unavailable
      lokiUrl
      checkedAt
      pods {
        name
        phase
        ready
        restarts
        nodeName
        reason
        message
        startTime
      }
      events {
        type
        reason
        message
        objectName
        count
        lastTimestamp
      }
      logs {
        podName
        container
        text
        tailLines
        error
      }
    }
  }
`
